import { Form, Input, Select, useSelect } from "@pankod/refine-antd";
import { MyFormProps } from ".";
import { IHealthInsurer } from "interfaces";
import { useInfiniteSelect } from "hooks/useInfiniteSelect";
import { useMemo } from "react";

export const CampaignForm: React.FC<MyFormProps> = ({
  formProps,
  queryResult,
}) => {
  const { selectProps: healthInsurerSelectProps } = useSelect<IHealthInsurer>({
    resource: "v1/health-insurer",
    optionLabel: "Description",
    optionValue: "HealthInsurerId",
  });

  const healthInsurerOptions = useMemo(() => {
    const options = healthInsurerSelectProps.options ?? [];
    const unifiedOption = { value: 9999, label: "Domínio Unificado" };

    const hasUnified = options.some(
      (option) => String(option?.value) === String(unifiedOption.value)
    );

    return hasUnified ? options : [...options, unifiedOption];
  }, [healthInsurerSelectProps.options]);

  const { defaultHealthInsurer, defaultPartner } = useMemo(() => {
    if (!queryResult?.data?.data?._id) return {};

    const defaultHealthInsurer = {
      value: queryResult.data.data?.health_insurer_id,
      label: queryResult.data.data?.health_insurer_name,
    };

    const defaultPartner = {
      value: queryResult.data.data?.partner_code,
      label: queryResult.data.data?.partner_name,
    };

    return { defaultHealthInsurer, defaultPartner };
  }, [queryResult?.data?.data]);

  const { selectProps: partnerSelectProps } = useInfiniteSelect({
    resource: "v1/partners",
    optionLabel: "partner_name",
    optionValue: "partner_code",
    sort: [{ field: "partner_name", order: "asc" }],
    pageSize: 20,
    defaultOption: defaultPartner,
  });

  return (
    <Form {...formProps} layout="vertical">
      <Form.Item
        label="Id da Campanha"
        name="campaign_id"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input type="number" placeholder="Id da Campanha" />
      </Form.Item>

      <Form.Item
        label="Operadora"
        name="health_insurer_id"
        rules={[
          {
            required: true,
          },
        ]}
        valuePropName="aaa"
      >
        <Select
          {...healthInsurerSelectProps}
          options={healthInsurerOptions}
          defaultValue={defaultHealthInsurer}
          placeholder="Operadora"
        />
      </Form.Item>

      <Form.Item
        label="Parceiro"
        name="partner_code"
        rules={[{ required: true, message: "Selecione o parceiro" }]}
        valuePropName="aaa"
      >
        <Select
          {...partnerSelectProps}
          defaultValue={defaultPartner}
          placeholder="Parceiro"
        />
      </Form.Item>

      <Form.Item
        label="Mensagem"
        name="message"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input.TextArea
          style={{
            width: "100%",
            height: "10rem",
            resize: "none",
          }}
          placeholder="Mensagem"
        />
      </Form.Item>

      <Form.Item
        label="Tag"
        name="tag"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input placeholder="Tag" />
      </Form.Item>
    </Form>
  );
};
